export default __webpack_public_path__ + "favicons/android-chrome-192x192.png";